import { Injectable, inject } from '@angular/core';
import { ISistema } from '@nomoh-monorepo/shared-types';
import { SistemasDataService } from './feature-sistemas.dataservice.service';

@Injectable({ providedIn: 'root' })
export class SistemasService {
  private sistemasDataService = inject(SistemasDataService);

  // PRINCÍPIO KISS: Component injeta DataService diretamente para signals
  // Service apenas para business logic com validações

  async carregarSistemas(): Promise<void> {
    // Business logic: Validar permissão (quando disponível)
    // await this.permissionService.validarPermissao('sistemas.read');

    return this.sistemasDataService.carregarSistemas();
  }

  async buscarSistemas(nome?: string | null): Promise<void> {
    // await this.permissionService.validarPermissao('sistemas.read');

    return this.sistemasDataService.buscar(nome);
  }

  async criarSistema(sistema: Omit<ISistema, 'id'>): Promise<ISistema | null> {
    // Business logic: Validar permissão crítica
    // await this.permissionService.validarPermissao('sistemas.create');

    // Validações de negócio
    if (!sistema.nome || sistema.nome.trim().length === 0) {
      throw new Error('Nome do sistema é obrigatório');
    }

    return this.sistemasDataService.criarSistema(sistema);
  }

  async atualizarSistema(sistema: ISistema): Promise<string | null> {
    // await this.permissionService.validarPermissao('sistemas.update');
    // Validações de negócio
    if (!sistema.id || sistema.id.trim().length === 0) {
      throw new Error('ID do sistema é inválido');
    }

    if (!sistema.nome || sistema.nome.trim().length === 0) {
      throw new Error('Nome do sistema é obrigatório');
    }

    return this.sistemasDataService.atualizarSistema(sistema);
  }

  async excluirSistema(id: string): Promise<boolean> {
    // await this.permissionService.validarPermissao('sistemas.delete');

    // Validação de negócio
    if (!id || id.trim().length === 0) {
      throw new Error('ID do sistema é inválido');
    }

    // Confirmação adicional pode ser feita no componente
    return this.sistemasDataService.excluirSistema(id);
  }

  async buscarPorId(id: string): Promise<ISistema | null> {
    // await this.permissionService.validarPermissao('sistemas.read');

    if (!id || id.trim().length === 0) {
      throw new Error('ID do sistema é inválido');
    }

    return this.sistemasDataService.buscarPorId(id);
  }

  // Métodos de navegação (sem validação adicional necessária)
  async proximaPagina(): Promise<void> {
    return this.sistemasDataService.proximaPagina();
  }

  async paginaAnterior(): Promise<void> {
    return this.sistemasDataService.paginaAnterior();
  }

  async irParaPagina(pagina: number): Promise<void> {
    return this.sistemasDataService.irParaPagina(pagina);
  }

  async limparFiltros(): Promise<void> {
    return this.sistemasDataService.limparFiltros();
  }
}
